import {useCallback, useEffect, useMemo, useState} from "react";
import axios from "axios";
import {API} from "../../helpers/constants";
import {enqueueSnackbar} from "notistack";
import {handleAxiosErrors, logoutUnauthorizedUser} from "../../helpers/errorHandling";
import {useTranslation} from "react-i18next";
import useUserData from "../user/useUserData";
import useUserAction from "../user/useUserAction";
import {REPORTS} from "../../locales/pages/namespaces";

const useReportStaticData = () => {
    const {t} = useTranslation(REPORTS)
    const {token, isLoggedIn} = useUserData()
    const {userLogout} = useUserAction()
    const [loading, setLoading] = useState(false)
    const [filtersData, setFiltersData] = useState({
        customers:[],
        categs: [],
        priorities: [],
        assignees: [],
        addresses: [],
        types: [],
        kinds:[],
        assets:[],
        items:[],
        FM:[]
    })

    const getFiltersData = useCallback(() => {
        setLoading(true)
        axios({
            method: 'get',
            url: `${API}/en/issues/filter/data`,
            headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`}
        }).then(res => {
            setFiltersData({
                types: res.data.types,
                customers: res.data.customers,
                categs: res.data.categories,
                priorities: res.data.priorities,
                addresses: res.data.sites,
                kinds:res.data.kinds,
                items:res.data.serviceItems,

                assets:res.data.assets,
                assignees: res.data.assignees,
                FM:res.data.FM,
            })
            console.log('data',res.data)
            setLoading(false)
        }).catch((error) => {
            setLoading(false)
            enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
                variant: 'error',
                autoHideDuration: 3000,
            })
            logoutUnauthorizedUser(error, isLoggedIn, userLogout)
        })
    }, [t, isLoggedIn, userLogout])

    useEffect(() => {
        getFiltersData()
    }, [])

    const customers = useMemo(() => (filtersData.customers), [filtersData.customers])
    const types = useMemo(() => (filtersData.types), [filtersData.types])
    const categs = useMemo(() => (filtersData.categs), [filtersData.categs])
    const priorities = useMemo(() => (filtersData.priorities), [filtersData.priorities])
    const assignees = useMemo(() => (filtersData.assignees), [filtersData.assignees])
    const addresses = useMemo(() => (filtersData.addresses), [filtersData.addresses])
    const kinds = useMemo(() => (filtersData.kinds), [filtersData.kinds])
    const assets = useMemo(() => (filtersData.assets), [filtersData.assets])
    const items = useMemo(() => (filtersData.items), [filtersData.items])
    const FM = useMemo(() => (filtersData.FM), [filtersData.FM])

    return {
        loading,
        customers,
        types,
        categs,
        priorities,
        assignees,
        addresses,
        kinds,
        assets,
        items,
        FM
    }
}
export default useReportStaticData